import { useQuery } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { getCurrentCardAssociatedWithTheUserAccount } from '@src/api'
import { GetCurrentCardAssociatedWithTheUserAccount200Response } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'
import { CustomError } from '@src/types'

export const useFetchCurrentCardAssociatedWithTheUserAccount = (
  userAccountId: string
) => {
  const { axiosInstance } = useAxios()
  return useQuery<
    AxiosResponse<GetCurrentCardAssociatedWithTheUserAccount200Response>,
    AxiosResponse<CustomError>
  >({
    enabled: !!userAccountId,
    queryFn: () =>
      getCurrentCardAssociatedWithTheUserAccount(axiosInstance, userAccountId),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_CURRENT_CARD_ASSOCIATED_WITH_THE_USER_ACCOUNT,
      userAccountId,
    ],
  })
}
